import React, { useEffect, useState } from 'react';
import ReusableSelect from '../common/Select';
import ComplianceSection from './ComplianceSection';
import { IEquipmentCompliance } from '../../type/equipmentCompliance';
import ViewStaffComplianceForm from '../common/ViewStaffComplianceForm';
import VehicleAndTrailerForm from './VeichleAndTrailerForm';
import ComplianceSelectBox from '../common/ComplianceSelectBox';
import useLocationStore from '../../store/locatonStore';
import { IComplianceStaff } from '../../type/complianceStaff';
import complianceApi from '../../api/complianceApi';
import { IUpdateStaffInEquipmentCompliance } from '../../type/updateStaffInEquipment';
import { toast } from 'react-toastify';
import { OPERATION_COMPLIANCE } from '../../constants/constant';

type Props = {
  data: IEquipmentCompliance[];
  writePermissionForEquipmentCompliance?: boolean;
  onStaffChange?: () => void;
  driverAccordionIsOpen?: boolean;
  toggleState?: (isOpen: boolean) => void;
  onSubmitSuccess?: () => void;
  editPermissionForBalloonCompliance?: boolean;
};

export type Staff = {
  name: string;
  staffId: number;
  contactStaffId: number;
};
// const ComplianceSection: React.FC<Props> = (
const AirCraftComplianceSection: React.FC<Props> = ({
  data,
  writePermissionForEquipmentCompliance,
  onStaffChange,
  driverAccordionIsOpen,
  toggleState,
  onSubmitSuccess,
  editPermissionForBalloonCompliance,
}) => {
  const [isEditMode, setEditMode] = useState(false);
  const [updatedAllocations, setUpdatedAllocations] = useState<{
    [key: number]: number;
  }>({});
  const [isEdit] = useState<boolean>(true);
  const handleStatusClick = (item: IEquipmentCompliance) => {
    setSelectedCompliance(item);
    setShowModal(true);
  };

  const selectedLocation = useLocationStore((state) => state.selectedLocation);
  const [apiResponse, setApiResponse] = useState<IComplianceStaff[]>([]);
  const [defaultStaffName, setDefaultStaffName] = useState<string | null>(null);

  useEffect(() => {
    fetchStaffList();
  }, [selectedLocation]);

  const fetchStaffList = async () => {
    const response = await complianceApi.getStaffList(selectedLocation.OwnerId);
    const staffList: IComplianceStaff[] = response?.data || [];
    setApiResponse(staffList);
  };

  const allocatedStaff = apiResponse?.reduce(
    (acc, item, idx) => {
      acc[idx] = item.staffId;
      return acc;
    },
    {} as { [key: number]: number },
  );

  const aircraftRows = data?.map((item, index) => {
    const statusColor =
      item.status == OPERATION_COMPLIANCE.statusExpired
        ? 'text-red-500'
        : item.status == OPERATION_COMPLIANCE.statusUpComing
          ? 'text-yellow-500'
          : 'text-gray-700';

    return [
      item?.complianceGroupDescription,
      item.equipmentTypeDescription,
      <div dangerouslySetInnerHTML={{ __html: item.equipmentName }} />,
      item?.complianceCategoryDescription,

      <span
        key={`status-${index}`}
        className={`font-semibold ${statusColor} ${editPermissionForBalloonCompliance ? 'cursor-pointer underline' : ''}`}
        onClick={() => {
          console.log('item', item);
          handleStatusClick(item);
        }}
      >
        {item.displayText}
      </span>,
      isEditMode ? (
        <ReusableSelect
          options={apiResponse}
          getOptionLabel={(option) => option.staffName}
          getOptionValue={(option) => option.staffId}
          onChange={(selectedStaff) =>
            handleAllocate(index, selectedStaff, item)
          }
          placeholder="Select"
          className="w-full p-1 bg-sidebar-background text-text-primary "
          value={updatedAllocations[index] ?? item?.allocatedStaffId}
          isDisabled={!isEditMode}
        />
      ) : (
        <span className="text-textBlack">
          {apiResponse.find((opt) => opt.staffId === item?.allocatedStaffId)
            ?.staffName || 'Unassigned'}
        </span>
      ),
    ];
  });

  const aircraftHeaders = [
    { label: 'Vehicle' },
    { label: 'Name' },
    { label: 'Compliance' },
    { label: 'Category' },
    { label: 'Status' },
    isEdit ? { label: 'Allocation' } : { label: 'Allocated to' },
  ];

  //TODO: I will update this any to right type

  const handleAllocate = (index: number, staff: any, item: any) => {
    console.log('-----------------------------');
    console.log(index, staff, item);
    setUpdatedAllocations((prev) => ({
      ...prev,
      [index]: staff.staffId,
    }));
  };

  const updateStaffInStaffCompliance = async (
    data: IUpdateStaffInEquipmentCompliance[],
  ) => {
    try {
      const response =
        await complianceApi.updateStaffInEquipmentCompliance(data);
      console.log(response);
      toast.success('Details updated successfully..');
      if (onStaffChange) {
        onStaffChange();
      }
    } catch (error) {
      console.log(error);
      toast.warn('Details not updated');
    }
  };

  const handleEdit = () => setEditMode(true);
  const handleCancel = () => setEditMode(false);
  const handleSave = () => {
    const allocations: IUpdateStaffInEquipmentCompliance[] = Object.entries(
      updatedAllocations,
    ).map(([index, staffId]) => {
      const equipmentItem = data[parseInt(index)];
      const staff = apiResponse.find((s) => s.staffId === staffId);
      return {
        complianceId: equipmentItem?.complianceId,
        equipmentId: equipmentItem?.equipmentId,
        equipmentTypeId: equipmentItem?.equipmentTypeId,
        allocStaffId: staff?.staffId,
        ownerId: selectedLocation?.OwnerId,
      };
    });

    updateStaffInStaffCompliance(allocations);
    console.log('Saved Allocations:', allocations);
    // Save logic here
    setEditMode(false);
  };
  const [showModal, setShowModal] = useState(false);
  const [selectedCompliance, setSelectedCompliance] =
    useState<IEquipmentCompliance | null>(null);

  return (
    <>
      <div className="ml-6 mr-4">
        <ComplianceSection
          title="Upcoming Air Craft Compliances"
          headers={aircraftHeaders}
          rows={aircraftRows}
          allocatedStaff={allocatedStaff}
          updatedAllocations={updatedAllocations}
          isEditMode={isEditMode}
          isEdit={isEdit}
          onEditClick={handleEdit}
          onCancel={handleCancel}
          onSave={handleSave}
          userCanEditStaffCompliance={writePermissionForEquipmentCompliance}
          driverAccordionIsOpen={driverAccordionIsOpen}
          editPermissionForBalloonCompliance={
            editPermissionForBalloonCompliance
          }
        />

        {showModal &&
          selectedCompliance &&
          editPermissionForBalloonCompliance && (
            <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center px-4">
              <VehicleAndTrailerForm
                name={selectedCompliance?.equipmentTypeDescription}
                compliance={selectedCompliance?.complianceDescription}
                recurrency={selectedCompliance?.complianceFrequencyDescription}
                note={selectedCompliance?.equipmentComplianceNote || undefined}
                status={selectedCompliance?.displayText}
                category={selectedCompliance?.equipmentTypeDescription}
                closeModal={() => setShowModal(false)}
                lastComplianceDateDisplay={
                  selectedCompliance?.lastComplianceDateDisplay
                }
                nextComplianceDate={selectedCompliance?.nextComplianceDate}
                complianceId={selectedCompliance?.complianceId}
                equipmentId={selectedCompliance?.equipmentId}
                equipmentTypeId={selectedCompliance.equipmentTypeId}
                onStaffChange={onStaffChange}
                onSubmitSuccess={onSubmitSuccess}
              />
            </div>
          )}
      </div>
    </>
  );
};

export default AirCraftComplianceSection;
